import React from 'react';

import { CustomEventNames, useMParticleContext } from 'state/mParticle';

type ClickHandler = (e: React.MouseEvent) => void;

export const useLogNavigationClick = (
  eventName?: CustomEventNames,
  onClick?: ClickHandler
): ClickHandler => {
  const mParticle = useMParticleContext();

  const handleClick = (e: React.MouseEvent) => {
    if (eventName) {
      mParticle.logNavigationClick(eventName);
    }

    if (onClick) {
      onClick(e);
    }

    return true;
  };

  return handleClick;
};
